import React from 'react';
import { connect } from 'react-redux'

import { isAuth, _setAxios, _success, _tableLogActivity, getParamTable, _validationFormMsg, _getDate, _warn } from '../../../lib/Helper';
import { schemaKonsultasi } from './schema';
import validate from 'validate.js';
import AuthRedirect from '../../../components/redirect/AuthRedirect'
import { PageHeader } from 'components/header';
import { Table, Row, Col, Divider, Popover, Button, Radio, Space, Menu, Dropdown, Input, Tooltip, Modal, Breadcrumb, List, message, Image, Tag } from 'antd';
import { SaveOutlined, InfoCircleOutlined, SearchOutlined, SortAscendingOutlined, EditOutlined, ExclamationCircleOutlined, DoubleRightOutlined, MessageOutlined, DeleteOutlined, SettingOutlined, DownCircleOutlined } from '@ant-design/icons';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MobileDatePicker from '@mui/lab/MobileDatePicker';
import Stack from '@mui/material/Stack';
import { noImage } from '../../../data/image';
import moment from 'moment';
import Preload from '../../../components/preload/PreloadContent'

const dateFormat = 'YYYY-MM-DD';

const tableOptions = {
    sorts: [{
        value: "ASC",
        label: "Ascending",
    }, {
        value: "DESC",
        label: "Descending",
    }],
    fields: [{
        value: "id",
        label: "Tanggal Pembuatan",
    }, {
        value: "nama",
        label: "Nama",
    }]
}

class Konsultasi extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            values: {},
            errors: {},

            table: {
                loading: false,
                data: [],
                search: "",
                pagination: {
                    current: 1,
                    pageSize: 10,
                    total: 0,
                },
                sorting: [{
                    field: "id",
                    sort: "DESC",
                    urutan: 1
                }],
                filtering: {},
            },
            dataDetail: {
                foto: null,
                data: {},
                data1: [
                    {
                        title: "NISN",
                        description: "-",
                    },
                    {
                        title: "Nama Peserta Didik",
                        description: "-",
                    },
                    {
                        title: "Jenis Kelamin",
                        description: "-",
                    },
                    {
                        title: "Rombel",
                        description: "-",
                    },
                    {
                        title: "No.Telepon",
                        description: "-",
                    },
                    {
                        title: "Alamat",
                        description: "-",
                    },
                ],
                data2: [
                    {
                        title: "Nama Wali",
                        description: "-",
                    },
                    {
                        title: "Status",
                        description: "-",
                    },
                    {
                        title: "No.Telepon",
                        description: "-",
                    },
                ],
                data3: [
                    {
                        title: "Nama Guru",
                        description: "-",
                    },
                    {
                        title: "Jenis Kelamin",
                        description: "-",
                    },
                    {
                        title: "No. Telepon",
                        description: "-",
                    },
                ],
            },
            detail: {
                visible: false,
                loading: false,
                data: []
            },
            form: {
                visible: false,
                loading: false,
            },
            ddl: {
                topik: []
            },
            fileList: [],
            validateFile: false,

            previewImage: '',
            previewTitle: '',
            visible: false,
            validateImage: false,

            dataID: this.props.privilege.profile_ex.siswa_id,
            rombelID: this.props.privilege.profile_ex.rombel_id,
        };
    }

    componentDidMount() {
        this.getDetailSiswa()
        this.fetchTable()
        this.getTopikDDL()

    }

    getTopikDDL = () => {
        _setAxios("konsultasi/topik", "GET").then(resp => {
            if (resp.status === true) {
                this.setState({
                    ddl: {
                        ...this.state.ddl,
                        topik: resp.data.data
                    },
                })
            }
        })
    }


    getDetailSiswa = () => {
        _setAxios("konsultasi/table-header-eksternal", "GET").then(resp => {
            if (resp.status === true) {
                const data = resp.data.data
                const gelarDepan = data.guru_gelar_depan ? data.guru_gelar_depan : ""
                const nama = data.guru_nama ? data.guru_nama : "-"
                const gelarBelakang = data.guru_gelar_belakang ? data.guru_gelar_belakang : ""
                const namaLengkap = gelarDepan + nama + gelarBelakang

                this.setState({
                    dataDetail: {
                        foto: data.foto ? data.main_path + data.foto : noImage,
                        data: data,
                        data1: [
                            {
                                title: "NISN",
                                description: data.siswa_nisn ? data.siswa_nisn : "-",
                            },
                            {
                                title: "Nama Peserta Didik",
                                description: data.siswa_nama ? data.siswa_nama : "-",
                            },
                            {
                                title: "Jenis Kelamin",
                                description: data.siswa_jenis_kelamin ? data.siswa_jenis_kelamin : "-",
                            },
                            {
                                title: "Rombel",
                                description: data.rombel_nama ? data.rombel_nama : "-",
                            },
                            {
                                title: "No. Telepon",
                                description: data.siswa_no_telp ? data.siswa_no_telp : "-",
                            },
                            {
                                title: "Alamat",
                                description: data.siswa_alamat ? data.siswa_alamat : "-",
                            },
                        ],
                        data2: [
                            {
                                title: "Nama Wali",
                                description: data.wali_nama ? data.wali_nama : "-",
                            },
                            {
                                title: "Status",
                                description: data.wali_tipe ? data.wali_tipe : "-",
                            },
                            {
                                title: "No. Telepon",
                                description: data.wali_no_telp ? data.wali_no_telp : "-",
                            },
                        ],
                        data3: [
                            {
                                title: "Nama Guru",
                                description: namaLengkap,
                            },
                            {
                                title: "Jenis Kelamin",
                                description: data.guru_jenis_kelamin ? data.guru_jenis_kelamin : "-",
                            },
                            {
                                title: "No. Telepon",
                                description: data.guru_no_telp ? data.guru_no_telp : "-",
                            },
                        ],
                    }
                })
            }
        })
    }

    fetchTable = () => {
        const { table } = this.state
        const params = getParamTable("default", table)
        this.fetch(params);
    }

    fetch = async (params = {}) => {
        this.setState({
            table: {
                ...params,
                loading: true
            }
        });
        _setAxios("konsultasi/table-eksternal", "POST", params).then(resp => {
            if (resp.status === true) {
                this.setState({
                    table: {
                        ...params,
                        loading: false,
                        data: resp.data.list,
                        pagination: {
                            ...params.pagination,
                            total: resp.data.info.total
                        }
                    }
                });
            } else {
                this.setState({
                    table: {
                        ...params,
                        loading: false,
                    }
                })
            }
        })
    };

    handleChange = (e) => {
        const { values } = this.state;
        const { name, value } = e.target;

        this.setForm(values, name, value)
    };

    handleChangeSetValue = (name, value) => {
        const { values } = this.state;
        this.setForm(values, name, value)
    };

    setForm = (values, name, value) => {
        values[name] = value;
        this.setValidate(values)
    }

    setValidate = (values) => {
        const errors = validate(values, schemaKonsultasi);
        this.setState({
            values: values,
            errors: errors || {},
        });
        return errors
    }

    hasError = field => {
        return this.state.errors[field] ? true : false;
    }

    // HANDLE FILE START --------------------------------------
    beforeUploadFile = (file) => {
        const isJpgOrPngPdf = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf';
        if (!isJpgOrPngPdf) {
            message.error('Anda bisa upload JPG/PNG/PDF file!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('File tidak boleh lebih besar dari 2MB!');
        }

        const flag = isJpgOrPngPdf && isLt2M

        if (flag === false) {
            this.setState({
                validateFile: false,
            })
            return false
        } else {
            this.setState({
                validateFile: true,
            })
        }
        return true
    };

    handleChangeFile = ({ fileList }) => {
        if (this.state.validateFile === true) {
            fileList.forEach((row, i) => {
                fileList[i].status = "done"
            });

            this.setState({
                fileList: fileList
            })
        } else {
            this.setState({
                fileList: null
            })
        }
    };
    // HANDLE FILE END --------------------------------------


    // CREATE START ------------------------------------------
    hideModalForm = (row) => {
        this.setState({
            form: {
                ...this.state.form,
                visible: false
            },
            values: {
                tgl: moment().format(dateFormat)
            },
            errors: {}
        });
    };

    showModalDetail = (row) => {
        this.setState({
            detail: {
                ...this.state.detail,
                visible: true,
                loading: true,
            },
        });

        _setAxios("konsultasi/" + row.id, "GET").then(resp => {
            if (resp.status === true) {
                const data = resp.data.data
                this.setState({
                    detail: {
                        ...this.state.detail,
                        loading: false,
                        data: [
                            {
                                title: "Tanggal Konsultasi",
                                description: data.tgl ? data.tgl : "-",
                            },
                            {
                                title: "Topik",
                                description: data.topik_nama ? data.topik_nama : "-",
                            },
                            {
                                title: "Status",
                                description: data.status ? <Tag color={data.status === "Selesai" ? "blue" : "warning"}>{data.status}</Tag> : "-",
                            },
                            {
                                title: "Uraian",
                                description: data.uraian ? data.uraian : "-",
                            },
                            {
                                title: "Tanggal Tanggapan",
                                description: data.tgl_tanggapan ? data.tgl_tanggapan : "-",
                            },
                            {
                                title: "Tanggapan",
                                description: data.tanggapan ? data.tanggapan : "-",
                            },
                        ]
                    },
                });
            } else {
                this.setState({
                    detail: {
                        ...this.state.detail,
                        loading: false,
                    },
                });
            }
        })
    };

    hideModalDetail = (row) => {
        this.setState({
            detail: {
                ...this.state.detail,
                visible: false,
            },
        });
    };

    showModalForm = (row) => {
        if (row.id) {
            this.setState({
                form: {
                    ...this.state.form,
                    visible: true,
                },

                values: {
                    id: row.id ? row.id : null,
                    tgl: row.tgl ? moment(row.tgl).format(dateFormat) : null,
                    topik_id: row.topik_id ? {
                        id: row.topik_id,
                        nama: row.topik_nama,
                    } : null,
                    uraian: row.uraian ? row.uraian : null,
                }
            });
        } else {
            this.setState({
                form: {
                    ...this.state.form,
                    visible: true,
                },
                values: {
                    tgl: moment().format(dateFormat),
                }
            });
        }
    };

    onSubmitForm = async (e) => {
        e.preventDefault();
        const { values } = this.state

        //Validation 
        let validation = this.setValidate(values, schemaKonsultasi)
        if (validation !== undefined) {
            return _validationFormMsg(validation)
        }

        let tgl = _getDate(values.tgl)

        // Payload
        const param = {
            // tahun_ajaran_id: this.props.privilege?.tahun_ajaran?.id,
            tgl: tgl,
            topik_id: values.topik_id ? values.topik_id.id : null,
            uraian: values.uraian ? values.uraian : null,
        }

        // Define Network
        let method = "POST"
        let endpoint = "konsultasi/eksternal"
        if (values.id) {
            method = "PUT"
            endpoint = "konsultasi/eksternal/" + values.id
        }

        this.setState({
            form: {
                ...this.state.form,
                loading: true
            }
        });
        _setAxios(endpoint, method, param).then(resp => {
            if (resp.status === true) {
                _success('topRight', 'Success', resp.data.message)
                this.hideModalForm()
                this.fetchTable()
            }

            this.setState({
                form: {
                    ...this.state.form,
                    loading: false
                }
            });
        })
    };

    // CREATE END ------------------------------------------


    onDelete = (row) => {
        Modal.confirm({
            title: 'Delete Data',
            icon: <ExclamationCircleOutlined />,
            content: <>Data akan dihapus dari list, Apakah Anda Yakin ?</>,
            cancelText: 'Batal',
            okText: 'Simpan',
            onOk: () => {
                return new Promise((resolve, reject) => {
                    _setAxios("konsultasi/" + row.id, "DELETE").then(resp => {
                        if (resp.status === true) {
                            _success('topRight', 'Success', resp.data.message)
                            this.fetchTable()
                        }
                        setTimeout(Math.random() > 0.5 ? resolve : reject, 100);
                    })
                }).catch(() => console.log('Oops errors!'));
            },
            onCancel: () => {
                console.log("No action to process")
            },
        });
    }

    onUpdateStatus = (row) => {
        const { dataDetail } = this.state

        if (!dataDetail.data.guru_no_telp) {
            _warn('topRight', 'Warning', "No. Telepon Guru Pembimbing tidak ditemukan, informasikan ke guru pembimbing (BK) untuk melengkapi data diri di system")
            return
        }

        const gelarDepan = dataDetail.data.guru_gelar_depan ? dataDetail.data.guru_gelar_depan : ""
        const nama = dataDetail.data.guru_nama ? dataDetail.data.guru_nama : "-"
        const gelarBelakang = dataDetail.data.guru_gelar_belakang ? dataDetail.data.guru_gelar_belakang : ""
        const namaLengkap = gelarDepan + nama + gelarBelakang

        const siswa_provinsi_nama = dataDetail.data.siswa_provinsi_nama ? dataDetail.data.siswa_provinsi_nama + ", " : ""
        const siswa_kabkot_nama = dataDetail.data.siswa_kabkot_nama ? dataDetail.data.siswa_kabkot_nama + ", " : "-"
        const siswa_kecamatan_nama = dataDetail.data.siswa_kecamatan_nama ? dataDetail.data.siswa_kecamatan_nama + ", " : ""
        const siswa_kelurahan_nama = dataDetail.data.siswa_kelurahan_nama ? dataDetail.data.siswa_kelurahan_nama + ", " : ""
        const siswa_alamat = dataDetail.data.siswa_alamat ? dataDetail.data.siswa_alamat : ""
        const addressSiswa = siswa_provinsi_nama + siswa_kabkot_nama + siswa_kecamatan_nama + siswa_kelurahan_nama + siswa_alamat


        Modal.confirm({
            title: 'Kirim Notifikasi ke Guru BK',
            width: 470,
            icon: false,
            content: <>Informasi Konsultasi akan dikirimkan ke guru BK, dan status pada daftar konsultasi akan berubah menjadi terkirim. <br /> Jadi pastikan kamu mengirimkan pesan di bidang teks pada chat konsultasi whatshapp kamu.</>,
            cancelText: 'Batal',
            okText: 'Kirim',
            onOk: () => {
                return new Promise((resolve, reject) => {

                    _setAxios("konsultasi/eksternal/terkirim/" + row.id, "PUT").then(resp => {
                        if (resp.status === true) {
                            _success('topRight', 'Success', resp.data.message)
                            this.fetchTable()
                            window.open('https://api.whatsapp.com/send?phone=' + dataDetail.data.guru_no_telp + '&text=Assalamualaikum%20wr,%20wb..%0Asaya%20*' + dataDetail.data.siswa_nama + '*%20ingin%20berkonsultasi%20dengan%20bapak/ibu%20*' + namaLengkap + '*%20tentang%20"_' + row.topik_nama + '_".%0A%20-%20Rombel:%20' + dataDetail.data.rombel_nama + '%0A%20-%20Alamat:%20' + addressSiswa + '%0A%20-%20Uraian:%20' + row.uraian + '%0A%20Mohon%20sekiranya%20bapak/ibu%20dapat%20membantu%20saya,%20Terimakasih.%0A%20Wassalamu%27alaikum');
                        }
                        setTimeout(Math.random() > 0.5 ? resolve : reject, 100);
                    })

                    // window.open('https://api.whatsapp.com/send?phone=' + dataDetail.data.guru_no_telp + '&text=Assalamualaikum%20wr,%20wb..%0Asaya%20*' + dataDetail.data.siswa_nama + '*%20ingin%20berkonsultasi%20dengan%20bapak/ibu%20*' + namaLengkap + '*%20tentang%20"_' + row.topik_nama + '_".%0A%20-%20Rombel:%20' + dataDetail.data.rombel_nama + '%0A%20-%20Alamat:%20' + addressSiswa + '%0A%20-%20Uraian:%20' + row.uraian + '%0A%20Mohon%20sekiranya%20bapak/ibu%20dapat%20membantu%20saya,%20Terimakasih.%0A%20Wassalamu%27alaikum');
                    // setTimeout(Math.random() > 0.5 ? resolve : reject, 100);


                }).catch(() => console.log('Oops errors!'));
            },
            onCancel: () => {
                console.log("No action to process")
            },
        });
    };

    render() {
        const access = this.props.privilege.access["/bimbingan-konseling/konsultasi"]
        const action = access !== undefined ? access.action : null

        if (!isAuth(this.props.privilege) || access === undefined || action.detail === false) {
            return <AuthRedirect />
        }

        const { table, values, errors, dataDetail, ddl } = this.state;

        const sortComponent = <>
            <Radio.Group onChange={(e) => {
                const params = getParamTable("sort_field", table, e.target.value)
                this.fetch(params)
            }} value={table.sorting.length > 0 ? table.sorting[0].field : "id"} name="sort_field">
                <Space direction="vertical">
                    {tableOptions.fields.map((row, i) => <Radio key={i} value={row.value}>{row.label}</Radio>)}
                </Space>
            </Radio.Group>
            <Divider orientation="left"></Divider>
            <Radio.Group onChange={(e) => {
                const params = getParamTable("sort", table, e.target.value)
                this.fetch(params)
            }} value={table.sorting.length > 0 ? table.sorting[0].sort : "id"} name="sort_value">
                <Space direction="vertical">
                    {tableOptions.sorts.map((row, i) => <Radio key={i} value={row.value}>{row.label}</Radio>)}
                </Space>
            </Radio.Group>
        </>

        const modalForm = <Modal
            title="Form Konseling"
            visible={this.state.form.visible}
            onCancel={this.hideModalForm}
            footer={<>
                <Button onClick={this.hideModalForm}>Batal</Button>
                <Button type="primary" htmlType="submit" onClick={this.onSubmitForm} loading={this.state.form.loading} icon={<SaveOutlined />}>Simpan</Button>
            </>}
        >
            <Row gutter={[16, 16]}>

                <Col xs={24}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <Stack spacing={3}>
                            <MobileDatePicker
                                label="Tanggal"
                                value={values.tgl || null}
                                onChange={(newValue) => {
                                    this.handleChangeSetValue("tgl", newValue)
                                }}
                                renderInput={(params) => <TextField
                                    size="small"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    error={this.hasError('tgl')}
                                    helperText={
                                        this.hasError('tgl') ? errors.tgl[0] : null
                                    }
                                    {...params} />}
                                readOnly={true}
                            />
                        </Stack>
                    </LocalizationProvider>
                </Col>
                <Col xs={24}>
                    <Autocomplete
                        options={ddl.topik}
                        value={values.topik_id || null}
                        getOptionLabel={(option) =>
                            option.nama
                        }
                        onChange={(e, newValue) => {
                            this.handleChangeSetValue("topik_id", newValue ? newValue : null)
                        }}
                        renderInput={(params) => <TextField {...params}
                            fullWidth
                            label="Topik"
                            size="small"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            name="topik_id"
                            type="text"
                            error={this.hasError('topik_id')}
                            helperText={
                                this.hasError('topik_id') ? errors.topik_id[0] : null
                            }
                        />}
                    />
                </Col>
                <Col xs={24}>
                    <TextField
                        multiline
                        fullWidth
                        label="Uraian"
                        size="small"
                        minRows={2}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        name="uraian"
                        type="text"
                        onChange={this.handleChange}
                        value={values.uraian || ''}
                        error={this.hasError('uraian')}
                        helperText={
                            this.hasError('uraian') ? errors.uraian[0] : null
                        }
                    />
                </Col>
            </Row>
        </Modal>

        const modalDetail = <Modal
            title="Detail Konseling"
            visible={this.state.detail.visible}
            onCancel={this.hideModalDetail}
            footer={<>
                <Button onClick={this.hideModalDetail}>Batal</Button>
            </>}
        >
            {
                this.state.detail.loading === true ? <Preload /> : <List
                    itemLayout="horizontal"
                    dataSource={this.state.detail.data}
                    renderItem={item => (
                        <List.Item>
                            <List.Item.Meta
                                title={item.title}
                                description={item.description}
                            />
                        </List.Item>
                    )}
                />
            }

        </Modal>

        return (
            <>
                <PageHeader
                    style={{
                        padding: 0
                    }}
                    onBack={() => window.history.back()}
                    title={<Breadcrumb style={{ margin: '16px 0' }} separator={<DoubleRightOutlined />}>
                        <Breadcrumb.Item>Bimbingan Konseling</Breadcrumb.Item>
                        <Breadcrumb.Item>Konsultasi</Breadcrumb.Item>
                    </Breadcrumb>}
                />
                <div style={{ textAlign: "center", marginBottom: 16 }}>
                    <Image
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '100%',
                        }}
                        width={100}
                        src={dataDetail.foto}
                    />
                </div>
                <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={8}>
                            <h5>Identitas Peserta Didik</h5>
                            <List
                                itemLayout="horizontal"
                                dataSource={dataDetail.data1}
                                renderItem={item => (
                                    <List.Item>
                                        <List.Item.Meta
                                            title={<><div style={{ float: "left", minWidth: 50 }}>{item.title}</div> : <small style={{ color: "rgb(119 105 105)" }}>{item.description}</small></>}
                                        />
                                    </List.Item>
                                )}
                            />
                        </Col>
                        <Col xs={24} sm={6}>
                            <h5>Identitas Wali Siswa</h5>
                            <List
                                itemLayout="horizontal"
                                dataSource={dataDetail.data2}
                                renderItem={item => (
                                    <List.Item>
                                        <List.Item.Meta
                                            title={<><div style={{ float: "left", minWidth: 50 }}>{item.title}</div> : <small style={{ color: "rgb(119 105 105)" }}>{item.description}</small></>}
                                        />
                                    </List.Item>
                                )}
                            />
                        </Col>
                        <Col xs={24} sm={6}>
                            <h5>Identitas Guru Pembimbing</h5>
                            <List
                                itemLayout="horizontal"
                                dataSource={dataDetail.data3}
                                renderItem={item => (
                                    <List.Item>
                                        <List.Item.Meta
                                            title={<><div style={{ float: "left", minWidth: 50 }}>{item.title}</div> : <small style={{ color: "rgb(119 105 105)" }}>{item.description}</small></>}
                                        />
                                    </List.Item>
                                )}
                            />
                        </Col>
                        <Col xs={24}>
                            <Divider />
                        </Col>
                        <Col xs={24}>
                            <PageHeader
                                className="site-page-header"
                                title="Riwayat Konseling"
                                extra={
                                    <Button type='primary' onClick={this.showModalForm}>Tambah</Button>
                                }
                            />
                        </Col>
                        <Col xs={24} sm={21}>
                            <Input
                                name="search"
                                className='search-table'
                                placeholder="Search..."
                                prefix={<SearchOutlined className="site-form-item-icon" />}
                                onChange={(e) => {
                                    const params = getParamTable("search", table, e.target.value)
                                    this.fetch(params)
                                }}
                                value={table.search || ""}
                                suffix={
                                    <Tooltip title="Cari berdasarkan nama">
                                        <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                                    </Tooltip>
                                }
                            />
                        </Col>
                        <Col xs={24} sm={3}>
                            <Button.Group className='ant-btn-group-fullwidth'>
                                <Popover placement="bottom" content={sortComponent} trigger="click">
                                    <Button block className='btn-border-radius-right'><SortAscendingOutlined /> Sort</Button>
                                </Popover>
                            </Button.Group>
                        </Col>
                        <Col xs={24}>
                            <Divider />
                        </Col>
                        <Col span={24}>
                            <Table
                                columns={[
                                    {
                                        title: 'No',
                                        dataIndex: 'rownum',
                                        width: '3%',
                                    },
                                    {
                                        title: 'Tanggal Konsultasi',
                                        dataIndex: 'tgl',
                                        width: '20%',
                                    },
                                    {
                                        title: 'Topik Konseling',
                                        dataIndex: 'topik_nama',
                                    },
                                    {
                                        title: 'Uraian',
                                        dataIndex: 'uraian',
                                        render: (a, row) => row.uraian ? row.uraian.slice(0, 50) + `...` : "-",
                                    },
                                    {
                                        title: 'Status',
                                        dataIndex: 'status',
                                        // render: (a, row) => row.status === "Selesai" ? <Tag style={{ minWidth: 170 }} color='blue'>{row.status}</Tag> : (row.status === "Draft" ? <Tag style={{ minWidth: 170 }} >{row.status}</Tag> : <Tag color='green' style={{ minWidth: 170 }}>{row.status}</Tag>),
                                        width: '20%',
                                    },
                                    {
                                        title: <SettingOutlined />,
                                        align: "center",
                                        key: 'operation',
                                        width: '2%',
                                        render: (a, row) => <Dropdown trigger={['click']} overlay={<Menu>
                                            <Menu.Item key={0} onClick={this.showModalDetail.bind(this, row)}><InfoCircleOutlined /> Detail</Menu.Item>
                                            {row.status !== "Draft" ? "" : <Menu.Item key={1} onClick={this.showModalForm.bind(this, row)}><EditOutlined /> Update</Menu.Item>}
                                            {row.status !== "Draft" ? "" : <Menu.Item key={2} onClick={this.onDelete.bind(this, row)}><DeleteOutlined /> Delete</Menu.Item>}
                                            {row.status === "Draft" ? <Menu.Item key={3} onClick={this.onUpdateStatus.bind(this, row)}><MessageOutlined /> Informasikan ke Guru BK</Menu.Item> : ""}
                                        </Menu>}>
                                            <Button type="primary">Opsi <DownCircleOutlined style={{ fontSize: 11 }} /></Button>
                                        </Dropdown>,
                                    },
                                    {
                                        title: 'LogActivity',
                                        key: 'operation',
                                        width: '10%',
                                        render: (a, row) => _tableLogActivity(row),
                                    },
                                ]}
                                rowKey={record => record.id}
                                dataSource={table.data}
                                pagination={table.pagination}
                                loading={table.loading}
                                onChange={(pagination) => {
                                    const params = getParamTable("change", table, null, null, pagination)
                                    this.fetch(params)
                                }}
                                size="small"
                            />
                        </Col>
                    </Row>
                </div>

                {modalForm}
                {modalDetail}
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        privilege: state.privilege,
    }
}

export default connect(mapStateToProps)(Konsultasi);
